<template>
	<div class="foot" :class="type == 'REISTER' ? '' : 'fixed'">
		<div class="footText">{{$t('components.foot1.text1')}}</div>
		<div class="footText">{{$t('components.foot1.text2')}}</div>
	</div>
</template>

<script>
	export default {
	  props: ['type']
	}
</script>

<style scoped>
	.foot{
		background-color: #505153;
		width: 100%;
		height: 96px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	
	.fixed{
		position: fixed;
		bottom: 0;
	}
	
	.footText{
		font-size: 12px;
		color: #ccc;
		line-height: 25px;
	}
</style>